<template>
  <generic-modal
    v-bind="$props"
    :loading="isLoading"
    :title="`Confirm Changes: ${filterContextString}`"
    :value="value"
    width="900"
    persistent
    v-on="$listeners"
  >
    <strong>
      If you are happy with your changes, please confirm to continue.
    </strong>
    <v-row justify="center">
      <v-col class="flex-grow-0">
        Previous Order:
        <v-list dense>
          <offer-item
            v-for="(offer, index) in previous"
            :key="`previous-offer-${offer.slug}`"
            :empty="offer.name === 'Empty slot'"
            :offer="offer"
            highlight-draft
            :position="index + 1"
          />
        </v-list>
      </v-col>
      <v-col class="d-flex align-center" sm="2">
        <v-icon color="cyan" size="80">double_arrow</v-icon>
      </v-col>
      <v-col class="flex-grow-0">
        New Order:
        <v-list dense>
          <offer-item
            v-for="(offer, index) in current"
            :key="`new-offer-${offer.slug}`"
            :empty="offer.name === 'Empty slot'"
            :offer="offer"
            highlight-draft
            :position="index + 1"
          />
        </v-list>
      </v-col>
    </v-row>
  </generic-modal>
</template>

<script>
import { mapGetters } from 'vuex'

import GenericModal from '@/components/modals/generic-modal'

import OfferItem from '@/views/offers/components/offer-item'

export default {
  name: 'OrderingConfirmModal',
  components: {
    GenericModal,
    OfferItem,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    previous: {
      type: Array,
      required: true,
    },
    current: {
      type: Array,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('options', ['formattedOption', 'options']),
    filterContextString() {
      const context = [
        this.findOptionData('countries', this.filters.country),
        this.findOptionData('offerTypes', this.filters.offerType),
        this.findOptionData('sites', this.filters.site),
      ]
        .filter(Boolean)
        .join(' ')

      return `${context} Tables`
    },
  },
  methods: {
    findOptionData(context, matcher) {
      return this.formattedOption(context, matcher).toUpperCase()
    },
  },
}
</script>
